var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-options rounded-desing"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.option.label))]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"file"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }